var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 7.041 15.32 6.239 14.419 6.046C14.779 5.445 15 4.75 15 4C15 1.794 13.206 0 11 0C9.483 0 8.179 0.857 7.5 2.104C6.821 0.857 5.517 0 4 0C1.794 0 0 1.794 0 4C0 4.902 0.312 5.727 0.817 6.396C0.564936 6.58091 0.359728 6.82233 0.217843 7.10089C0.0759581 7.37945 0.00134793 7.68739 0 8V16C0 17.103 0.897 18 2 18H14C15.103 18 16 17.103 16 16V13.362L20 15.362V8.362L16 10.362V8ZM11 2C12.103 2 13 2.897 13 4C13 5.103 12.103 6 11 6C9.897 6 9 5.103 9 4C9 2.897 9.897 2 11 2ZM4 2C5.103 2 6 2.897 6 4C6 5.103 5.103 6 4 6C2.897 6 2 5.103 2 4C2 2.897 2.897 2 4 2ZM2 16V8H14L14.002 16H2Z",
    fill: "#016E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilms);
export default __webpack_public_path__ + "static/media/Films.0c2c5fc050a987b2c97888dba4c6c079.svg";
export { ForwardRef as ReactComponent };